import { SelectOption } from '@navstation-portal/shared/data-model/common';

export const SWELL_OPTIONS: SelectOption[] = [
  { name: '0 - No Swell', code: 0 },
  { name: '1 - Very Low', code: 1 },
  { name: '2 - Low', code: 2 },
  { name: '3 - Light', code: 3 },
  { name: '4 - Moderate', code: 4 },
  { name: '5 - Moderate Rough', code: 5 },
  { name: '6 - Rough', code: 6 },
  { name: '7 - High', code: 7 },
  { name: '8 - Very High', code: 8 },
  { name: '9 - Confused', code: 9 },
] as const;
